export { default } from 'shared/components/context/scrollbar'
